import React, { useState, useContext } from "react";
import Drawer from "../../Drawer";
import { handleErrors } from "../../../utils/errors";
import StatusMessage from "../../StatusMessage";
import { NotificationsContext } from "../../NotificationsProvider";
import CustomerGroupForm from "./CustomerGroupForm";

const CustomerGroupFormDrawer = ({
    onClose,
    onSuccess,
    action,
    values,
    uuid,
    title,
    customers
}) => {
    const [formError, setFormError] = useState();
    const notificationCtx = useContext(NotificationsContext);
    const isEdit = action === "edit";
    const saveDetails = ({ value, callback }) => {
        const {customer_ids} = value;
        const dedupCustomerIds =  [...new Set(customer_ids)];
        fetch(
            isEdit ?
                `/api/customers/groups/${uuid}` :
                '/api/customers/groups',
            {
                method: action === "edit" ? 'PUT' : 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ...value,
                    customer_ids: dedupCustomerIds
                }),
            }).then(handleErrors)
            .then((data) => {
                notificationCtx.showNotification({
                    type: 'success',
                    message: `Group ${action === "edit" ? "updated" : "created"}`
                });
                if (callback) callback({uuid: data?.uuid});
                return data;
            })
            .catch(setFormError);
    };

    return (
        <Drawer
            title={title || `${isEdit ? "Edit " : "Create new "}group`}
            onClose={onClose}
        >
            {formError && (<StatusMessage apiError={formError} margin={{top: 'small'}} />)}
            <CustomerGroupForm
                onSubmit={(event) => {
                    saveDetails({
                        value: event.value,
                        callback: onSuccess,
                    });
                }}
                onCancel={onClose}
                companyNameRequired={true}
                values={values || undefined}
                customers={customers}
            />
        </Drawer>
    );
}

export default CustomerGroupFormDrawer;
